export const ru = {
    'icon-title': 'Рекомендации',
    'popup-title': 'Рекомендации'
};
